import { useEffect, useState } from 'react';
import classnames from 'classnames';
import { SearchInput } from '@/components/UI/Common/SearchInput';
import { Button } from '@/components/UI/Common/Button';

interface Props {
  className?: string;
  onChange: (text: string) => void;
  value?: string;
}

export const UserApplicationSearch: React.FC<Props> = ({ value = '', onChange, className }) => {
  const [showButton, setShowButton] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const hasText = value?.trim().length > 0;

  useEffect(() => {
    if (hasText && !showButton) {
      setShowButton(true);
      setTimeout(() => setIsVisible(true), 10);
    } else if (!hasText && showButton) {
      setIsVisible(false);
      setTimeout(() => setShowButton(false), 300);
    }
  }, [hasText, showButton, value]);

  const handleChangeSearchText = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const handleCleanSearchText = () => {
    onChange('');
  };

  return (
    <div className={classnames(className, 'relative w-full min-w-0 p-4 lg:flex-1 lg:p-8')}>
      <SearchInput
        className="inline-block w-full"
        placeholder="Поиск приложений"
        value={value}
        onChange={handleChangeSearchText}
      />

      {showButton && (
        <div
          className={classnames(
            'flex-shrink-0 transition-all duration-300 ease-out transform mt-4',
            isVisible ? 'translate-x-0 opacity-100' : '-translate-x-4 opacity-0',
          )}
        >
          <Button onClick={handleCleanSearchText} className="rounded-lg whitespace-nowrap min-w-0">
            Показать все приложения
          </Button>
        </div>
      )}
    </div>
  );
};
